import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
  selector: 'app-auth-logo',
  imports: [CommonModule],
  templateUrl: './auth-logo.component.html',
  styleUrl: './auth-logo.component.scss',
})
export class AuthLogoComponent {}
